import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import { useUpdateCall } from '../../lib/api/update'

export const ProjectSettings = ({
  closeSettings,
  pagesContent,
  setSelectedTheme,
  isLocalEnvironment,
  authDetails,
}) => {
  const updateCallMutation = useUpdateCall()
  const [errors, setErrors] = React.useState({})
  const [imageFile, setImageFile] = React.useState(null)
  const [faviconPath, setFaviconPath] = React.useState(null)
  const webSettings = JSON.parse(pagesContent.websiteProjectSettings)

  const uploadImage = async () => {
    let formData = new FormData()
    formData.append('file', imageFile)
    formData['type'] = 'Image'
    axios
      .post(`${isLocalEnvironment}/upload?endPoint=image`, formData, {
        headers: {
          tokenSource: 'passport',
          Authorization: `Bearer ${authDetails.authentication.tokenObject}`,
        },
      })
      .then((resp) => setFaviconPath(resp.data.formData.fileUrl))
  }
  const update = async (e) => {
    e.preventDefault()
    if (e.target.themeColor.value === '' || e.target.themeColor.value === null) {
      setErrors({ ...errors, themeColor: { message: 'Theme color is required!' } })
      return
    }
    if (
      errors.themeColor &&
      (e.target.themeColor.value !== '' || e.target.themeColor.value !== null)
    ) {
      delete errors['themeColor']
      setErrors(errors)
    }
    if (e.target.primaryColor.value === '' || e.target.primaryColor.value === null) {
      setErrors({ ...errors, primaryColor: { message: 'Primary color is required!' } })
      return
    }
    if (
      errors.primaryColor &&
      (e.target.primaryColor.value !== '' || e.target.primaryColor.value !== null)
    ) {
      delete errors['primaryColor']
      setErrors(errors)
    }

    const payload = JSON.parse(pagesContent.websiteProjectSettings)
    payload['favicon'] =
      faviconPath !== null
        ? faviconPath ||
          'https://thulisha-cdn.azureedge.net/2EFBB98A-7329-4052-9609-5FD2CB294205/favicon.png'
        : JSON.parse(pagesContent.websiteProjectSettings).favicon ||
          'https://thulisha-cdn.azureedge.net/2EFBB98A-7329-4052-9609-5FD2CB294205/favicon.png'
    payload['themeColor'] = e.target.themeColor.value
    payload['primaryColor'] = e.target.primaryColor.value

    if (webSettings.primaryHoverColor) {
      if (e.target.primaryHoverColor.value === '' || e.target.primaryHoverColor.value === null) {
        setErrors({ ...errors, primaryHoverColor: { message: 'Primary hover color is required!' } })
        return
      }
      if (
        errors.primaryHoverColor &&
        (e.target.primaryHoverColor.value !== '' || e.target.primaryHoverColor.value !== null)
      ) {
        delete errors['primaryHoverColor']
        setErrors(errors)
      }
      payload['primaryHoverColor'] = e.target.primaryHoverColor.value
    }
    if (webSettings.secondaryColor) {
      if (e.target.secondaryColor.value === '' || e.target.secondaryColor.value === null) {
        setErrors({ ...errors, secondaryColor: { message: 'Secondary color is required!' } })
        return
      }
      if (
        errors.secondaryColor &&
        (e.target.secondaryColor.value !== '' || e.target.secondaryColor.value !== null)
      ) {
        delete errors['secondaryColor']
        setErrors(errors)
      }
      payload['secondaryColor'] = e.target.secondaryColor.value
    }
    if (webSettings.sendaryHoverColor) {
      if (e.target.sendaryHoverColor.value === '' || e.target.sendaryHoverColor.value === null) {
        setErrors({
          ...errors,
          sendaryHoverColor: { message: 'Secondary Hover color is required!' },
        })
        return
      }
      if (
        errors.sendaryHoverColor &&
        (e.target.sendaryHoverColor.value !== '' || e.target.sendaryHoverColor.value !== null)
      ) {
        delete errors['sendaryHoverColor']
        setErrors(errors)
      }
      payload['sendaryHoverColor'] = e.target.sendaryHoverColor.value
    }
    if (webSettings.lightColor) {
      if (e.target.lightColor.value === '' || e.target.lightColor.value === null) {
        setErrors({ ...errors, lightColor: { message: 'Light color is required!' } })
        return
      }
      if (
        errors.lightColor &&
        (e.target.lightColor.value !== '' || e.target.lightColor.value !== null)
      ) {
        delete errors['lightColor']
        setErrors(errors)
      }
      payload['lightColor'] = e.target.lightColor.value
    }
    if (webSettings.darkColor) {
      if (e.target.darkColor.value === '' || e.target.darkColor.value === null) {
        setErrors({ ...errors, darkColor: { message: 'Dark color is required!' } })
        return
      }
      if (
        errors.darkColor &&
        (e.target.darkColor.value !== '' || e.target.darkColor.value !== null)
      ) {
        delete errors['darkColor']
        setErrors(errors)
      }
      payload['darkColor'] = e.target.darkColor.value
    }

    const data = {
      websiteName: pagesContent.websiteName,
      websiteProjectId: pagesContent.websiteProjectId,
      themeId: pagesContent.themeId,
      userId: pagesContent.userId,
      appId: pagesContent.appId,
      tenantId: pagesContent.tenantId,
      websiteProjectNavbar: pagesContent.websiteProjectNavbar,
      websiteProjectFooter: pagesContent.websiteProjectFooter,
      websiteProjectSettings: JSON.stringify(payload),
      websiteProjectIsPublished: pagesContent.websiteProjectIsPublished,
    }
    await updateCallMutation.mutateAsync({
      url: isLocalEnvironment + '/updateData',
      apiEndpoint: 'websiteProjects',
      data: data,
      id: pagesContent.websiteProjectId,
      messageTitle: 'Website Settings',
      message: 'Website settings updated!',
      isDynamic: true,
      params: `&isDependency=true&targetTenantId=${authDetails.session.user.appAdmin.tenantId}&targetAppId=${authDetails.session.user.appAdmin.appId}&targetOrgId=${authDetails.session.user.appAdmin.orgId}`,
    })
  }
  return (
    <div
      className="trtui-modal trtui-modal-xxl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{
        display: 'block',
        backgroundColor: 'rgba(55,55,55,0.3)',
      }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-dialog-scrollable trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              Settings
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => closeSettings()}
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-row">
              <div className="trtui-col-6 trtui-mb-2 trtui-text-center">
                <a
                  href={`navbar-editor?project=${pagesContent.websiteProjectId}${
                    pagesContent.websiteProjectIsPublished === 0 ||
                    pagesContent.websiteProjectIsPublished === true
                      ? '&notPublished=true&themeId=' + pagesContent.themeId
                      : '&themeId=' + pagesContent.themeId
                  }&targetTenantId=${authDetails.session.user.appAdmin.tenantId}&targetAppId=${authDetails.session.user.appAdmin.appId}&targetOrgId=${authDetails.session.user.appAdmin.orgId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    const storage = sessionStorage.getItem('auth')
                    localStorage.setItem('sessionStorage', storage)
                    setSelectedTheme(pagesContent.themeId)
                  }}
                  className="trtui-btn trtui-btn-sm trtui-btn-primary trtui-mb-2"
                >
                  Navbar
                </a>
              </div>
              <div className="trtui-col-6 trtui-mb-2 trtui-text-center">
                <a
                  href={`footer-editor?project=${pagesContent.websiteProjectId}${
                    pagesContent.websiteProjectIsPublished === 0 ||
                    pagesContent.websiteProjectIsPublished === true
                      ? '&notPublished=true&themeId=' + pagesContent.themeId
                      : '&themeId=' + pagesContent.themeId
                  }&targetTenantId=${authDetails.session.user.appAdmin.tenantId}&targetAppId=${authDetails.session.user.appAdmin.appId}&targetOrgId=${authDetails.session.user.appAdmin.orgId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    const storage = sessionStorage.getItem('auth')
                    localStorage.setItem('sessionStorage', storage)
                    setSelectedTheme(pagesContent.themeId)
                  }}
                  className="trtui-btn trtui-btn-sm trtui-btn-primary trtui-mb-2"
                >
                  Footer
                </a>
              </div>
              <form className="trtui-row" onSubmit={update}>
                <div className="trtui-col-9 trtui-mb-2">
                  <label htmlFor="favicon" className="trtui-form-label">
                    Favicon
                  </label>
                  <div className="trtui-input-group">
                    <input
                      type="file"
                      className={`trtui-form-control ${errors.favicon && 'trtui-is-invalid'}`}
                      placeholder="Favicon URL"
                      onChange={(e) => setImageFile(e.target.files[0])}
                      name="favicon"
                      aria-describedby="basic-addon3"
                    />
                    <button
                      className="trtui-btn trtui-btn-success trtui-btn-sm"
                      onClick={uploadImage}
                      type="button"
                    >
                      Upload
                    </button>
                    {errors.favicon && (
                      <div className="trtui-invalid-feedback">{errors.favicon.message}</div>
                    )}
                  </div>
                </div>
                <div className="trtui-col-3 trtui-mb-2">
                  <img
                    key={faviconPath}
                    style={{ width: '64px', height: '64px' }}
                    src={
                      faviconPath !== null
                        ? faviconPath
                        : JSON.parse(pagesContent.websiteProjectSettings).favicon.replace(
                            '%2F',
                            '/',
                          )
                    }
                    alt="Favicon"
                  />
                </div>
                <div className="trtui-col-6">
                  <label htmlFor="themeColor" className="trtui-form-label">
                    Theme Color
                  </label>
                  <input
                    type="color"
                    className={`trtui-form-control trtui-form-control-color trtui-w-100 ${errors.themeColor && 'trtui-is-invalid'}`}
                    placeholder="Theme Color"
                    defaultValue={JSON.parse(pagesContent.websiteProjectSettings).themeColor}
                    name="themeColor"
                  />
                  {errors.themeColor && (
                    <div className="trtui-invalid-feedback">{errors.themeColor.message}</div>
                  )}
                </div>
                {JSON.parse(pagesContent.websiteProjectSettings).primaryColor && (
                  <div className="trtui-col-6">
                    <label htmlFor="primaryColor" className="trtui-form-label">
                      Primary Color
                    </label>
                    <input
                      type="color"
                      className={`trtui-form-control trtui-form-control-color trtui-w-100 ${errors.primaryColor && 'trtui-is-invalid'}`}
                      placeholder="Primary Color"
                      defaultValue={JSON.parse(pagesContent.websiteProjectSettings).primaryColor}
                      name="primaryColor"
                    />
                    {errors.primaryColor && (
                      <div className="trtui-invalid-feedback">{errors.primaryColor.message}</div>
                    )}
                  </div>
                )}
                {JSON.parse(pagesContent.websiteProjectSettings).primaryHoverColor && (
                  <div className="trtui-col-6">
                    <label htmlFor="primaryHoverColor" className="trtui-form-label">
                      Primary Hover Color
                    </label>
                    <input
                      type="color"
                      className={`trtui-form-control trtui-form-control-color trtui-w-100 ${errors.primaryHoverColor && 'trtui-is-invalid'}`}
                      placeholder="Primary Color"
                      defaultValue={
                        JSON.parse(pagesContent.websiteProjectSettings).primaryHoverColor
                      }
                      name="primaryHoverColor"
                    />
                    {errors.primaryHoverColor && (
                      <div className="trtui-invalid-feedback">
                        {errors.primaryHoverColor.message}
                      </div>
                    )}
                  </div>
                )}
                {JSON.parse(pagesContent.websiteProjectSettings).secondaryColor && (
                  <div className="trtui-col-6">
                    <label htmlFor="secondaryColor" className="trtui-form-label">
                      Secondary Color
                    </label>
                    <input
                      type="color"
                      className={`trtui-form-control trtui-form-control-color trtui-w-100 ${errors.secondaryColor && 'trtui-is-invalid'}`}
                      placeholder="secondary Color"
                      defaultValue={JSON.parse(pagesContent.websiteProjectSettings).secondaryColor}
                      name="secondaryColor"
                    />
                    {errors.secondaryColor && (
                      <div className="trtui-invalid-feedback">{errors.secondaryColor.message}</div>
                    )}
                  </div>
                )}
                {JSON.parse(pagesContent.websiteProjectSettings).secondaryHoverColor && (
                  <div className="trtui-col-6">
                    <label htmlFor="secondaryHoverColor" className="trtui-form-label">
                      Secondary Hover Color
                    </label>
                    <input
                      type="color"
                      className={`trtui-form-control trtui-form-control-color trtui-w-100 ${errors.secondaryHoverColor && 'trtui-is-invalid'}`}
                      placeholder="secondary Color"
                      defaultValue={
                        JSON.parse(pagesContent.websiteProjectSettings).secondaryHoverColor
                      }
                      name="secondaryHoverColor"
                    />
                    {errors.secondaryHoverColor && (
                      <div className="trtui-invalid-feedback">
                        {errors.secondaryHoverColor.message}
                      </div>
                    )}
                  </div>
                )}
                {JSON.parse(pagesContent.websiteProjectSettings).lightColor && (
                  <div className="trtui-col-6">
                    <label htmlFor="lightColor" className="trtui-form-label">
                      Light Color
                    </label>
                    <input
                      type="color"
                      className={`trtui-form-control trtui-form-control-color trtui-w-100 ${errors.lightColor && 'trtui-is-invalid'}`}
                      placeholder="Primary Color"
                      defaultValue={JSON.parse(pagesContent.websiteProjectSettings).lightColor}
                      name="lightColor"
                    />
                    {errors.lightColor && (
                      <div className="trtui-invalid-feedback">{errors.lightColor.message}</div>
                    )}
                  </div>
                )}
                {JSON.parse(pagesContent.websiteProjectSettings).darkColor && (
                  <div className="trtui-col-6">
                    <label htmlFor="darkColor" className="trtui-form-label">
                      Dark Color
                    </label>
                    <input
                      type="color"
                      className={`trtui-form-control trtui-form-control-color trtui-w-100 ${errors.darkColor && 'trtui-is-invalid'}`}
                      placeholder="Primary Color"
                      defaultValue={JSON.parse(pagesContent.websiteProjectSettings).darkColor}
                      name="darkColor"
                    />
                    {errors.darkColor && (
                      <div className="trtui-invalid-feedback">{errors.darkColor.message}</div>
                    )}
                  </div>
                )}
                <div className="trtui-col-12 trtui-mt-3">
                  <button type="submit" className="trtui-btn trtui-btn-success">
                    {updateCallMutation.isLoading ? 'Updating...' : 'Update'}
                  </button>{' '}
                  <button
                    type="button"
                    onClick={closeSettings}
                    className="trtui-btn trtui-btn-secondary"
                    disabled={updateCallMutation.isLoading ? true : false}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ProjectSettings.propTypes = {
  setSelectedTheme: PropTypes.func,
  closeSettings: PropTypes.func.isRequired,
  pagesContent: PropTypes.object.isRequired,
  isLocalEnvironment: PropTypes.string.isRequired,
  authDetails: PropTypes.object.isRequired,
}
